'use strict';

/**
 * Layout for a conversation not found
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('modules/community/templates/layout/conversation-not-found.hbs');

var ConversationNotFoundLayout = LayoutView.extend({
    template: template,

    className: function() {
        return 'conversation-container conversation-type-not-found';
    },

    ui: {
        'closeLink': 'a.close',
    },

    events: {
        'click @ui.closeLink': 'close',
    },

    close: function(event) {
        event.preventDefault();
        App.router.navigate(this.getOption('closeUrl'), {trigger: true, replace: true});
    },
});

module.exports = ConversationNotFoundLayout;